var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysAcceptedTerms = function SvgSysAcceptedTerms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "sysAcceptedTerms_svg__a",
    width: 64,
    height: 64,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M64 0H0v64h64V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#sysAcceptedTerms_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.514 17.607a3.907 3.907 0 0 1 2.763-1.144h11.63a1 1 0 0 1 .707.293l8.722 8.722a1 1 0 0 1-1.414 1.414l-8.43-8.43H23.278a1.907 1.907 0 0 0-1.907 1.908v23.26a1.907 1.907 0 0 0 1.907 1.907h16.977a2.375 2.375 0 0 0 2.375-2.375v-3.287a1 1 0 1 1 2 0v3.287a4.375 4.375 0 0 1-4.375 4.375H23.277a3.907 3.907 0 0 1-3.907-3.907V20.37c0-1.036.411-2.03 1.144-2.763Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.907 16.463a1 1 0 0 1 1 1v7.722h7.722a1 1 0 1 1 0 2h-8.722a1 1 0 0 1-1-1v-8.722a1 1 0 0 1 1-1ZM44.52 30.73a1 1 0 0 1 0 1.415l-7.5 7.499a1 1 0 0 1-1.415 0l-3.75-3.75a1 1 0 0 1 1.415-1.414l3.042 3.043 6.793-6.793a1 1 0 0 1 1.415 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.285 6.131a28 28 0 1 1 21.43 51.738 28 28 0 0 1-21.43-51.738Zm15.787.369a26 26 0 1 0-10.144 51 26 26 0 0 0 10.144-51Z"
  }))));
};
export default SvgSysAcceptedTerms;